export const CONFIG = {
  VIDEO_URL_DESKTOP: 'https://storage.googleapis.com/argo-app-prod/static/outlaw_web.mp4',
  supportEmail: 'info@ot4.life',
  companyName: 'Outlaw Tech',
  TITLE: 'Outlaw Tech',
  domen: 'https://ot4.life',
}
